import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { LoginService } from '../../services/login.service';
import { UserGroup, User } from '../../classes/user';
import { GlobalSearchService } from '../../services/globalsearchservice.service';
import { GlobalsService } from '../../services/globals.service';
import { DispatchService } from '../../services/dispatch.service';
import { DeviceService } from '../../services/device.service';
import * as jsotp from 'jsotp';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

import * as QRCode from 'qrcode';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';



@Component({
	selector: 'app-login',
	templateUrl: './login.component.html',
	styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
	public loginForm: UntypedFormGroup;
	public registerForm: UntypedFormGroup;
	public logo = '/assets/logo.png';
	public result: any;
	public user: any;
	public txterror: any;
	public config: any = false;
	public systemType: any = '';
	public deviceRegistered = false;
	public userHasDeviceRegistered = false;
	public awaiting2FA = false;
	private deviceKey = '';
	public deviceDetails: any = [];
	public deviceInfo: any = [];
	public currentUser: any = null;
	public qrCodeDataUrl = '';
	public isLoggingIn = false;
	public loginEndpoint = '';
	public apiKey = '';
	public fullEndpointUrl = '';
       @ViewChild('twoFAHelp', { static: true }) twoFAHelpTemplate: any;

       constructor(
              private globalsService: GlobalsService,
              private dispatchService: DispatchService,
              private formBuilder: UntypedFormBuilder,
              private loginService: LoginService,
              public router: Router,
              public globalSearchService: GlobalSearchService,
              private deviceService: DeviceService,
              private modalService: NgbModal
       ) {
       	this.globalSearchService.configsubscription.subscribe(r => {
       		this.config = r;
       		this.logo = r?.env?.package ? `/assets/${r.env.package}.png` : '/assets/logo.png';
       	});

       	this.createLoginForm();
       	this.createRegisterForm();

       	const uuid = this.deviceService.getDeviceUUID();
       	this.deviceKey = 'registeredDevice_' + uuid;
       	this.deviceRegistered = localStorage.getItem(this.deviceKey) === 'true';
       	this.userHasDeviceRegistered = false;
       }

       openHelpModal() {
       	this.modalService.open(this.twoFAHelpTemplate, { centered: true });
       }

       onPasswordKeyDown(event: KeyboardEvent) {
       	if (event.key === 'Enter' && !this.isLoggingIn && !this.awaiting2FA) {
       		event.preventDefault();
       		this.onLogin();
       	}
       }

       createLoginForm() {
       	this.loginForm = this.formBuilder.group({
       		userName: [''],
       		password: [''],
       		twoFactorCode: [''],
       		txterror: ['']
       	});
       }

       otpCode: string[] = ['', '', '', '', '', ''];

       onOtpInput(event: any, index: number) {
       	const input = event.target as HTMLInputElement;
       	const val = input.value;
       
       	if (!/^\d$/.test(val)) {
       		input.value = '';
       		return;
       	}
       
       	this.otpCode[index] = val;
       
       	// Move to next input
       	if (val && index < 5) {
       		const nextInput = document.getElementById(`otp-${index + 1}`) as HTMLInputElement;
       		nextInput?.focus();
       	}
       
       	this.updateOtpFormControl();
       
       	// Auto-submit if all 6 digits filled
       	if (this.otpCode.every(d => d !== '')) {
       		setTimeout(() => this.onTwoFactorSubmit(), 100);
       	}
       
       	this.loginForm.get('txterror')?.setValue('');
       	this.txterror = '';
       }

       onOtpKeyDown(event: KeyboardEvent, index: number) {
       	const input = event.target as HTMLInputElement;
       
       	if (event.key === 'Backspace') {
       		if (!input.value && index > 0) {
       			const prevInput = document.getElementById(`otp-${index - 1}`) as HTMLInputElement;
       			prevInput?.focus();
       		}
       		return;
       	}
       
       	// Handle paste directly from keydown (backup to paste listener)
       	if ((event.ctrlKey || event.metaKey) && event.key.toLowerCase() === 'v') {
       		navigator.clipboard.readText().then(text => {
       			const digits = text.replace(/\D/g, '').slice(0, 6).split('');
       			digits.forEach((digit, i) => {
       				this.otpCode[i] = digit;
       				const el = document.getElementById(`otp-${i}`) as HTMLInputElement;
       				if (el) {el.value = digit;}
       			});
       			this.updateOtpFormControl();
       
       			if (digits.length === 6) {
       				setTimeout(() => this.onTwoFactorSubmit(), 100);
       			}
       		});
       	}
       }

       updateOtpFormControl() {
       	const joined = this.otpCode.join('');
       	this.loginForm.get('twoFactorCode')?.setValue(joined);
       }

       createRegisterForm() {
       	this.registerForm = this.formBuilder.group({
       		userName: [''],
       		password: [''],
       		confirmPassword: [''],
       		txterror: ['']
       	});
       }

       verifyTwoFactor(code: string): boolean {
       	const secret = 'KVKFKRCPNZQUYMLXOVYDSQKJKZDTSRLD';
       	const totp = jsotp.TOTP();
       	return totp.verify(code, secret);
       }

       public gatherOnly = false;

       async onLogin () {
       	if (this.isLoggingIn) {
       		return; // Prevent multiple simultaneous login attempts
       	}

       	this.isLoggingIn = true;
       	this.loginEndpoint = this.config?.apiServer?.endpoint || 'API Endpoint';
       	this.apiKey = this.config?.apiCredentials?.clientId || 'No API Key';
       	this.fullEndpointUrl = `${this.loginEndpoint}login&key=${this.apiKey}`;
       	this.loginForm.get('txterror')?.setValue('');
       	this.txterror = '';

       	const basicPayload = {
       		userName: this.loginForm.value.userName,
       		password: this.loginForm.value.password
       	};

       	const deviceInfo = await this.deviceService.getFullDeviceId();

       	const payload = {
       		...basicPayload,
       		deviceInfo // includes uuid, fingerprint, and info block
       	};

       	this.loginService.login(payload).subscribe({
       		next: (user: any) => {
       		this.user = user;

       		if (user.pass) {
       			if (!user.user?.twofactor) {
       				this.gatherOnly = true;
       			} else {
       				this.gatherOnly = false;
       			}

       			// If we're gathering only, skip 2FA
       			if (this.gatherOnly) {
       				//console.log('Gathering device info only, skipping 2FA.');
       				this.finishLogin();
       				return;
       			}

       			this.deviceRegistered = user.user?.device_trusted;
       			this.userHasDeviceRegistered = user.user?.has_trusted

       			// If the device is not yet registered, require 2FA

       			if (!this.deviceRegistered && user.user?.twofactor === '1') {
       				setTimeout(() => {
       					const el = document.getElementById('otp-0') as HTMLInputElement;
       					el?.focus();
       				}, 100);

       				this.awaiting2FA = true;
       				this.loginForm.get('txterror').setValue('Device not recognized. Please enter your 2FA code.');

       				if (this.deviceInfo.uuid) {
       					this.user.otpAuthUrl = this.generateOtpAuthUrl(this.deviceInfo.uuid, user.user.userid);
       				}

       				return;
       			} else {
       				this.finishLogin();
       			}


       		} else {
       			this.txterror = user.error;
       			this.loginForm.get('txterror')?.setValue(user.error);
       			this.isLoggingIn = false;
       		}
       		},
       		error: (error) => {
       			console.error('Login error:', error);
       			let errorMessage = 'Login failed. Please try again.';
       			
       			if (error.error && error.error.message) {
       				errorMessage = error.error.message;
       			} else if (error.message) {
       				errorMessage = error.message;
       			} else if (error.status === 401) {
       				errorMessage = 'Invalid username or password.';
       			} else if (error.status === 0) {
       				errorMessage = 'Cannot connect to server. Please check your connection.';
       			} else if (error.status >= 500) {
       				errorMessage = 'Server error. Please try again later.';
       			}
       			
       			this.txterror = errorMessage;
       			this.loginForm.get('txterror')?.setValue(errorMessage);
       			this.isLoggingIn = false;
       		}
       	});
       }

       onTwoFactorSubmit() {
       	const code = this.loginForm.get('twoFactorCode')?.value;
       	if (!code) {
       		this.txterror = 'Please enter your 2FA code.';
       		this.loginForm.get('txterror').setValue(this.txterror)
       		return;
       	}

       	this.loginService.verify2FA({
       		userName: this.loginForm.value.userName,
       		code,
       		deviceInfo: this.deviceInfo
       	}).subscribe((res: any) => {
       		if (res.success) {
       			localStorage.setItem(this.deviceKey, 'true');
       			this.deviceRegistered = true;
       			this.userHasDeviceRegistered = true;
       			this.awaiting2FA = false;
       			this.finishLogin();
       		} else {
       			this.txterror = res.message || 'Invalid 2FA code.';
       			this.loginForm.get('txterror').setValue(this.txterror)
       		}
       	});
       }

       finishLogin() {
       	this.isLoggingIn = false;
       	localStorage.setItem('user', JSON.stringify(this.user));

       	this.globalSearchService.getColor();
       	this.globalSearchService.user.next(this.user);
       	this.globalSearchService.selectedlocation.next(this.user.user.defaultlocation.loccode);

       	this.dispatchService.getTrucks().subscribe((result: any) => {
       		if (result.length === 1) {
       			this.router.navigate(['/dispatches/load-sheet']);
       		} else {
       			this.router.navigate([
       				this.user.user.showdashboard === '1' ? '/orders/entry' : 'dashboard'
       			]);
       		}
       	});
       }

       uuidToTOTPSecret(uuid: string): string {
       	const cleanUUID = uuid.replace(/-/g, '');

       	// Convert hex string to bytes
       	const bytes = [];
       	for (let i = 0; i < cleanUUID.length; i += 2) {
       		bytes.push(parseInt(cleanUUID.substr(i, 2), 16));
       	}

       	// Base32 encode manually (RFC 4648, Crockford’s alphabet)

       	const alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ234567';
       	let bits = '';
       	let base32 = '';

       	for (const byte of bytes) {
       		bits += byte.toString(2).padStart(8, '0');
       	}

       	for (let i = 0; i < bits.length; i += 5) {
       		const chunk = bits.substr(i, 5);
       		if (chunk.length < 5) {break;}
       		base32 += alphabet[parseInt(chunk, 2)];
       	}

       	return base32.padEnd(32, 'A');
       }

       apiKeyToTOTPSecret(apiKey: string): string {
       	const alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ234567';
       	let bits = '';
       	let base32 = '';

       	for (let i = 0; i < apiKey.length; i++) {
       		const byte = apiKey.charCodeAt(i); // direct byte of the string
       		bits += byte.toString(2).padStart(8, '0');
       	}

       	for (let i = 0; i < bits.length; i += 5) {
       		const chunk = bits.substr(i, 5);
       		if (chunk.length < 5) {break;}
       		base32 += alphabet[parseInt(chunk, 2)];
       	}

       	return base32.padEnd(32, 'A'); // match PHP padding
       }

       generateOtpAuthUrl(secret: string, username: string): string {
       	let title = 'BeautyServ V8'
       	switch (this.systemType) {
       	case 'tires':
       		title = 'TireServV8'
       		break;
       	case 'beauty':
       		title = 'BeautyServV8'
       		break;
       	default:
       		title = 'BeautyServV8'
       		break;
       	}
       	const issuer = title;

       	const secret_key = this.apiKeyToTOTPSecret(this.config.apiCredentials.clientId);
       	const final = `otpauth://totp/${issuer}:${username}?secret=${secret_key}&issuer=${issuer}`
       	this.generateQRCode(final)
       	return final;
       }



       generateQRCode(value: string) {
       	QRCode.toDataURL(value, { width: 256 }, (err, url) => {
       		if (err) {
       			console.error('QR Code generation failed', err);
       		} else {
       			console.log(value)
       			this.qrCodeDataUrl = url;
       		}
       	});
       }

       async ngOnInit (): Promise < void > {
       	this.deviceInfo = await this.deviceService.getFullDeviceId();

       	const storedUser = localStorage.getItem('user');
       	if (storedUser) {
       		try {
       			this.currentUser = JSON.parse(storedUser);
       		} catch (e) {
       			console.error('Invalid user data in localStorage');
       		}
       	}
       }
}